import { RevenueDeepDiveModal } from 'modules';



export const RevenueDeepDive = () => {
  return (
    <RevenueDeepDiveModal.FC />
  );
};
